import virementEmisData from '../data/virement-emis.json';
import virementRecuData from '../data/virement-recu.json';
import reponseVirementRecuData from '../data/reponse-virement-recu.json';
import virementEnvoiAnnulationData from '../data/envoi-annulation.json';
import virementReceptionAnnulationData from '../data/reception-annulation.json';
import virementEnvoiRetourFondData from '../data/envoi-retour-fond.json';
import virementReceptionRetourFondData from '../data/reception-retour-fond.json';
import virementEnvoiInversionData from '../data/envoi-inversion.json';
import virementReceptionInversionData from '../data/reception-inversion.json';

// Import des processus chèques
import chequePresenteData from '../data/cheque-presente.json';
import chequeRecuPaiementData from '../data/cheque-recu-paiement.json';
import chequeReponsePresentationData from '../data/cheque-reponse-presentation.json';
import chequeRetourReceptionData from '../data/cheque-retour-reception.json';







const ProcessService = {
  async loadAllProcessFiles() {
    try {
      const processData = { 
        processes: [
          // Processus virements
          ...virementEmisData.processes,
          ...virementRecuData.processes,
          ...reponseVirementRecuData.processes,
          ...virementEnvoiAnnulationData.processes,
          ...virementReceptionAnnulationData.processes,
          ...virementEnvoiRetourFondData.processes,
          ...virementReceptionRetourFondData.processes,
          ...virementEnvoiInversionData.processes,
          ...virementReceptionInversionData.processes,

          // Processus chèques
          ...chequePresenteData.processes,
          ...chequeRecuPaiementData.processes,
          ...chequeReponsePresentationData.processes,
          ...chequeRetourReceptionData.processes,

    
        ]
      };

      console.log('Processus chargés:', processData.processes);
      return processData;
    } catch (error) {
      console.error('Erreur lors du chargement des processus:', error);
      throw error;
    }
  },

  async loadProcessById(processId) {
    try {
      console.log('Recherche du processus avec ID:', processId);
      const allProcesses = await this.loadAllProcessFiles();
      const foundProcess = allProcesses.processes.find(p => p.id === processId);
      console.log('Processus trouvé:', foundProcess);
      return foundProcess;
    } catch (error) {
      console.error('Erreur lors du chargement du processus par ID:', error);
      throw error;
    }
  }
};

export default ProcessService;